import { Component, Input } from "@angular/core";
import { ICreditAmount, ITotalDiscountsByContract } from "@edp-models/total-discount-contract.model";

@Component({
  selector: "edp-savings",
  templateUrl: "./edp-savings.component.html",
  styleUrls: ["./edp-savings.component.scss"]
})
export class EdpSavingsComponent {

  @Input() set allDiscounts(discounts: ITotalDiscountsByContract) {
    if (!this.discounts) {
      this.discounts = discounts;
      this.checkContracts(this.discounts.creditAmount);
    }
  }

  public totalDiscount: number;
  public thirdPartyDiscounts: number;
  public showAllMoneySaved = false;
  public showThird: boolean;
  public consumptionLocations: number;
  public thirdName: string;
  public discounts: ITotalDiscountsByContract;

  private userContracts: ICreditAmount[] = [];
  private thirdPartyContracts: ICreditAmount[] = [];
  private userMoneySaved: number;
  private thirdMoneySaved: number;
  public onlyThird: ICreditAmount = null;

  private checkContracts(creditAmount: ICreditAmount[]): void {
    this.totalDiscount = 0;
    creditAmount.forEach((info: ICreditAmount) => {
      // Save contracts that are managed by the current user.
      if (!info.contract.IsManaged || (info.contract.IsManaged && !info.contract.IsManagedByMe)) {
        this.userContracts.push(info);
      } else {
        this.thirdPartyContracts.push(info);
      }
    });

    if (this.userContracts.length > 0) {
      this.userSavedMoney(this.userContracts);
    }

    if (this.thirdPartyContracts.length > 0) {
      this.thirdSavedMoney(this.thirdPartyContracts);
    }

    this.checkSavedMoney();
  }

  private checkSavedMoney(): void {
    if (this.userMoneySaved > 0 && this.thirdMoneySaved > 0) {
      this.totalDiscount = this.userMoneySaved + this.thirdMoneySaved;
      this.showAllMoneySaved = true;
    } else if (this.userMoneySaved > 0) {
      this.totalDiscount = this.userMoneySaved;
    } else if (this.thirdMoneySaved > 0) {
      this.totalDiscount = this.thirdMoneySaved;
      this.showAllMoneySaved = false;
      this.showThird = true;
    } else {
      this.totalDiscount = this.discounts.totalCreditAmount;
    }
  }

  private userSavedMoney(userContracts: ICreditAmount[]): void {
    this.userMoneySaved = 0;
    userContracts.forEach((info: ICreditAmount) => {
      this.userMoneySaved = this.userMoneySaved + info.totalCreditAmount;
    });
  }

  private thirdSavedMoney(thirdPartyContracts: ICreditAmount[]): void {
    this.thirdMoneySaved = 0;
    const thirdWithMoney = [];
    thirdPartyContracts.forEach((info: ICreditAmount) => {
      if (info.totalCreditAmount > 0) {
        this.thirdMoneySaved = this.thirdMoneySaved + info.totalCreditAmount;
        thirdWithMoney.push(info.contract.ContractId);
      }
    });

    if (this.thirdMoneySaved > 0 && thirdWithMoney.length > 0) {
      if (thirdWithMoney.length > 1) {
        this.consumptionLocations = thirdWithMoney.length;
      } else {
        this.onlyThird = thirdPartyContracts.find(info => info.contract.ContractId === thirdWithMoney[0]);
        this.thirdName = this.onlyThird && this.onlyThird.contract.CustomerFirstName + " " + this.onlyThird.contract.CustomerLastName;
      }
    }
  }
}
